import { jsxs, jsx } from "react/jsx-runtime";
const IconAISvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M12 20a1 1 0 0 1-.895-.553l-2.183-4.369-4.37-2.183a1 1 0 0 1 0-1.79l4.37-2.183 2.183-4.37c.34-.677 1.45-.677 1.79 0l2.183 4.37 4.37 2.183a1 1 0 0 1 0 1.79l-4.37 2.183-2.183 4.37A1 1 0 0 1 12 20Zm-4.764-8 2.878 1.438c.194.097.35.254.448.448L12 16.764l1.438-2.878c.097-.194.254-.35.448-.448L16.764 12l-2.878-1.438a1.001 1.001 0 0 1-.448-.448L12 7.236l-1.438 2.878c-.097.194-.254.35-.448.448L7.236 12Zm2.431-2.333h.01-.01ZM3.985 3.912l1-2 1 2 2 1-2 1-1 2-1-2-2-1 2-1Z" })
    ]
  }
);
export {
  IconAISvg
};
